'use client';

import type React from 'react';

import { Check } from 'lucide-react';
import { useCertification } from '../contexts/certification-context';
import { toast } from 'sonner';

interface Step {
  id: number;
  // title: string;
  icon: React.ReactNode;
}

interface CertificationProgressProps {
  currentStep: number;
}

export function CertificationProgress({ currentStep }: CertificationProgressProps) {
  const { latestCompletedStep, selectedCertificate, setCurrentStep } = useCertification();
  if (!selectedCertificate) return null;
  const stepsLength = Object.keys(selectedCertificate.steps).length;
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        {Object.entries(selectedCertificate.steps).map(([id, step]) => {
          const stepId = parseInt(id);
          const title = selectedCertificate.steps[stepId]?.stepTitle;

          return (
            <>
              <div
                key={stepId}
                className={`flex min-w-fit flex-col items-center space-y-2 ${
                  stepId < currentStep
                    ? 'text-green-600'
                    : stepId === currentStep
                    ? 'text-primary'
                    : 'text-gray-400'
                }`}
                onClick={() => {
                  if (latestCompletedStep >= stepId) {
                    setCurrentStep(stepId);
                  } else {
                    toast.error(
                      `Du skal gennemføre tidligere trin for at gå videre til "${title}"`
                    );
                  }
                }}
              >
                <div
                  className={`
              flex h-8 w-8 items-center justify-center rounded-full border-2
              ${
                stepId < currentStep
                  ? 'border-green-600 bg-green-100'
                  : stepId === currentStep
                  ? 'border-primary'
                  : 'border-gray-300'
              }
            `}
                >
                  {stepId < currentStep ? <Check className="h-4 w-4" /> : step.icon}
                </div>
                <span className="text-xs font-medium text-center">{title}</span>
              </div>
              {stepId < stepsLength && (
                <div
                  className={`h-0.5 w-full flex-grow hidden md:block -mt-5 mx-0 ${
                    stepId < currentStep ? 'bg-green-600' : 'bg-gray-300'
                  }`}
                  // style={{ marginLeft: '100%' }}
                />
              )}
            </>
          );
        })}
      </div>
    </div>
  );
}
